module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.products) ? _c('div', {
    staticClass: "ecommerce-carousel donate-carousel",
    attrs: {
      "id": "ecommerce-carousel"
    }
  }, [_c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "product-slide"
    }, [_c('a', {
      attrs: {
        "href": product.url
      }
    }, [_c('div', {
      staticClass: "product-card"
    }, [_c('div', {
      staticClass: "product-image",
      style: ('background-image: url(' + product.image + ')')
    }), _vm._v(" "), _c('p', {
      staticClass: "product-label"
    }, [_vm._v(_vm._s(product.name) + " "), _c('span', {
      staticClass: "card-arrow"
    }, [_c('i', {
      staticClass: "fas fa-chevron-right"
    })])])])])])
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a2384c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=tqk19250jg!./~/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./src/components/ecommerce/EcommerceCarousel.vue
// module id = 704
// module chunks = 0